import React from 'react';
import dash_img from "../assets/images/man-with-laptop.png";
import PrimarySidebar from '../PrimarySidebar/PrimarySidebar';

const MyProfile = () => {

  return (
    <div>
        <PrimarySidebar />
    <div className="js-pg-hg">
      <div className="container pt-5">
        <div className="row justify-content-center">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
           <div class="heading mb-4">
           <h4>Veritis Group Inc</h4>
           </div>

          <div class="row g-6">
           <div class="col-lg-3 mb-4 col-sm-6">
      <div class="card card-border-shadow-primary shadow-sm rounded-4 p-4 h-100">
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <h2 class="mb-0 fw-600">42</h2>
          </div>
          <p class="mb-3 fs-5">Leads</p>
          <p class="mb-0">
            <span class="text-heading fw-medium me-2">+18.2%</span>
            <span class="text-body-secondary">than last week</span>
          </p>
        </div>
      </div>
    </div>

    <div class="col-lg-3 mb-4 col-sm-6">
      <div class="card card-border-shadow-primary shadow-sm rounded-4 p-4 h-100">
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <h2 class="mb-0 fw-600">200</h2>
          </div>
          <p class="mb-3 fs-5">Followers</p>
          <p class="mb-0">
            <span class="text-heading fw-medium me-2">+18.2%</span>
            <span class="text-body-secondary">than last week</span>
          </p>
        </div>
      </div>
    </div>



    <div class="col-lg-3 mb-4 col-sm-6">
      <div class="card card-border-shadow-primary shadow-sm rounded-4 p-4 h-100">
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <h2 class="mb-0 fw-600">150</h2>
          </div>
          <p class="mb-3 fs-5">Following</p>
          <p class="mb-0">
            <span class="text-heading fw-medium me-2">+18.2%</span>
            <span class="text-body-secondary">than last week</span>
          </p>
        </div>
      </div>
    </div>


    <div class="col-lg-3 mb-4 col-sm-6">
      <div class="card card-border-shadow-primary shadow-sm rounded-4 p-4 h-100">
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <h2 class="mb-0 fw-600">0</h2>
          </div>
          <p class="mb-3 fs-5">Messages</p>
          <p class="mb-0">
            <span class="text-heading fw-medium me-2">+18.2%</span>
            <span class="text-body-secondary">than last week</span>
          </p>
        </div>
      </div>
    </div>
    </div>

      <div class="card shadow-sm rounded-4">
        <div class="d-flex align-items-center row">
          <div class="col-sm-8">
            <div class="card-body px-4 mx-2">
              <h5 class="card-title text-primary mb-3">Review a Company</h5>
              <p class="mb-6">Leaving a review helps Comapany leaders like you make a confident choice.</p>

              <a href="javascript:;" class="btn btn-primary">Write a Review</a>
            </div>
          </div>
          <div class="col-sm-4 text-center text-sm-left">
            <div class="card-body pb-0 px-0 px-md-6">
              <img src={dash_img} height="175" class="scaleX-n1-rtl" alt="View Badge User" />
            </div>
          </div>
        </div>
      </div>

          </div>
        </div>
      </div>

      <div>

    </div>
    </div>

    </div>
  );
};

export default MyProfile;